import styled from "styled-components";
import { device } from "./Device";

const ContainerMoreContact = styled.div`
  margin: 20px;
`;
const ContentMoreContact = styled.div`
  opacity: 0.6;
  transition: 0.5s;
  a {
    margin: 0;
    padding: 0;
    color: #385da6;
    text-decoration: none;
    font-weight: bold;
    @media ${device.laptopL} {
      font-size: 12px;
      color: red;
    }
  }
  img {
    max-width: 110px;
  }
  h3 {
    margin: 10px 0 0;
    padding: 0;
    color: white;
    text-align: center;
    font-size: 3em;
    text-transform: uppercase;
    font-family: "Allerta Stencil";

    @media ${device.laptopL} {
      font-size: 1.5em;
    }
  }
  p {
    margin: 10px 0 0;
    padding: 0;
    text-align: center;
    font-size: 2em;
    font-family: "Oswald", sans-serif;

    @media ${device.laptopL} {
      font-size: 1em;
    }
  }
`;

const Face1 = styled.div`
  transition: 0.5s;
  position: relative;
  background: #385da6;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  transform: translateY(100px);
  width: 400px;
  height: 308px;
  border-radius: 10%;

  @media ${device.laptopL} {
    width: 157px;
    height: 154px;
  }
`;
const Face2 = styled.div`
  transition: 0.5s;
  position: relative;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8);
  transform: translateY(-190px);
  width: 399px;
  height: 290px;
  border-radius: 11%;
  font-family: "Allerta Stencil";

  @media ${device.laptopL} {
    transform: translateY(-50px);
    width: 153px;
    height: 73px;
  }
`;
const PortfolioShow = styled.video`
  width: 100%;
`;

const CardMoreContact = styled.div`
  position: relative;
  margin: 0 auto;

  &:hover ${Face1} {
    background: #f24b4b;
    transform: translateY(0);
  }

  &:hover ${Face2} {
    transform: translateY(0);
  }

  &:hover ${ContentMoreContact} {
    o
    pacity: 1;
  }
`;

export {
  ContainerMoreContact,
  ContentMoreContact,
  CardMoreContact,
  Face1,
  Face2,
  PortfolioShow,
};
